import { Popover, PopoverContent, PopoverTrigger } from "./ui/Popover";
import { ChevronDown } from "lucide-react"
import RefinementList from "./RefinementList";
import RefinementToggle from "./RefinementToggle";
import RefinementListToggle from "./RefinementListToggle";
import { cn } from "../../utils/cn";
import { FilterAttribute, useVirtualFilters, toggleFilters } from "../../search-shared/VirtualFilters";
import InStockFilter from "./InStockFilter";

export default function QuickFilters() {
    const filters = useVirtualFilters();
    const filterOptions = [
        // { label: "Category", attribute: filters.category, filter: FilterAttribute.CATEGORY },
        { label: "Product Type", attribute: filters.productType, filter: FilterAttribute.PRODUCT_TYPE },
        { label: "Brand", attribute: filters.brand, filter: FilterAttribute.BRAND },
    ];

    // Filter to show only the most important toggles in quick filters
    const quickToggleFilters = ['Best Sellers', 'In Stock & Ready to Ship', 'On Sale']

    return (
        <>
            {filterOptions.map(({ label, attribute, filter }) => (
                <Popover key={filter}>
                    <PopoverTrigger disabled={!attribute.canRefine} className={styles.popoverTrigger}>
                        {label} <ChevronDown className={styles.icon} />
                    </PopoverTrigger>

                    <PopoverContent className={styles.popoverContent}>
                        <RefinementList attribute={filter} />
                    </PopoverContent>
                </Popover>
            ))}

            {toggleFilters.map((item) => {
                // render all toggle to keep their state in sync
                // if (!quickToggleFilters.includes(item.label)) {
                //     return null;
                // }
                const componentProps = {
                    attribute: item.attribute,
                    children: <div>{item.label}</div>,
                    className: cn(styles.toggle, "tw-text-nowrap", !quickToggleFilters.includes(item.label) ? "tw-hidden" : "")
                };

                if(item.type === 'inStock') {
                    return (
                        <InStockFilter
                            key={item.label}
                            {...componentProps}
                            min={item.min || 1}
                        />
                    );
                }

                return item.type === 'refinementList' ? (
                    <RefinementListToggle 
                        key={item.label}
                        {...componentProps}
                        value={item.on as string}
                    />
                ) : (
                    <RefinementToggle 
                        key={item.label}
                        {...componentProps}
                        on={item.on}
                    />
                );
            })}
        </>
    );
}

const styles = {
    popoverTrigger:
        "tw-whitespace-nowrap disabled:tw-cursor-not-allowed tw-flex tw-flex-row tw-items-center tw-bg-white tw-text-sm tw-font-[500]",
    popoverContent: "tw-bg-white",
    icon: "tw-h-[15px] tw-w-[15px]",
    toggle: "tw-flex tw-flex-row tw-items-center tw-m-0 tw-bg-white tw-text-sm tw-font-[500] [&>div]:tw-order-1",
};